export default __webpack_public_path__ + "static/media/(75).b7f15fa8.jpg";